import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import Radium from 'radium';
import Waves from 'node-waves'
import $ from 'jquery';
import {semanticColors} from '../Globals/styles';
import { getWeeknumber, getDates } from '../Util/dateTime';

/* if you will adjust datepicker settings ->
  read the docs and eat your vegestables bro !
https://bootstrap-datepicker.readthedocs.org/en/latest/options.html*/
require('bootstrap-datepicker')
require('bootstrap-datepicker/js/locales/bootstrap-datepicker.da.js')

class Trashcan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date : null
    }
  }
  componentDidMount() {
    this.$i = $(ReactDOM.findDOMNode(this.refs.datepicker));
    this.$i.datepicker({
      format: 'DD d MM yyyy',
      weekStart: 1,
      autoclose: true,
      language: 'da-DA',
      calendarWeeks: true,
      todayHighlight: true,
      todayBtn: 'linked'
    }).on('changeDate', this.onDatepickerChange);

    let initDate = this.props.defaultValue ? this.props.defaultValue : new Date();
    this.setState({
      date: initDate
    });
    Waves.attach('.waves-btn', ['waves-button']);
  }
  componentWillReceiveProps(nextProps) {
    if(this.state.date != nextProps.defaultValue) {
      this.setState({
        date: nextProps.defaultValue
      })
    }
  }
  componentDidUpdate = () => {
    Waves.attach('.waves-btn', ['waves-button']);
  };
  componentWillUnmount = () => {
    this.$i.datepicker('remove');
  };
  onDatepickerChange = (evt) => {
    this.props.onChange(evt.date);
    this.setState({
      date: evt.date
    })
  };
  onDatepicked = (evt) => {
    let newDate = new Date(evt.date).setHours(0,0,0,0);
    this.$i.datepicker('setDate', new Date(newDate));
  };
  render() {
    var weekDates = getDates(this.state.date);
    var days = [];
    for (let day in weekDates){
      days.push(
        <div
          className="waves-btn"
          key={day}
          style={[styles.divInLine, this.state.date.getDate()===weekDates[day].date.getDate() && styles.activeDate]}
          onClick={() => this.onDatepicked(weekDates[day])}>
            <div style={[
              styles.date,
              styles.date.label
              ]}>
              {weekDates[day].label}
            </div>
            <div style={[
              styles.date,
              styles.date.number]}>
              {weekDates[day].date.getDate()}
            </div>
        </div>
      );
    }
    return (
      <div>
          <div className="col-xs-12"
                style={styles.dateRow}>
              {this.state.date ?
                <div style={styles.divInLine}>
                  {days}
                </div>
              : null}
              <i ref="datepicker" style={styles.i} className="fa fa-calendar waves-btn">
                <div style={styles.uge}> Uge {this.state.date ? getWeeknumber(this.state.date) : null}</div>
              </i>
          </div>
      </div>
    );
  }
}

var styles = {
  dateRow: {
    fontSize: '16px'
  },
  divInLine : {
    display:'inline-block',
    cursor:'pointer',
    color: semanticColors.text,
    ':hover': {
      color: semanticColors.infoHover
    },
    padding: '0px',
    borderRadius: '0px',
    overflow: 'none',
    lineHeight:'normal',
    verticalAlign: 'bottom'
  },
  date: {
    textAlign:'center',
    width: '50px',
    label: {
        fontSize:'12px'
    },
    number : {
      borderLeft: '1px solid',
      borderColor: semanticColors.mainBackground
    }
  },
  i : {
    borderLeft: '1px solid',
    borderColor: semanticColors.mainBackground,
    height: '22px',
    lineHeight: '22px',
    fontSize:'18px',
    cursor: 'pointer',
    padding: '0px 0px 0px 15px',
    borderRadius: '0px'
  },
  uge: {
    display:'inline-block',
    paddingLeft:'10px',
    cursor: 'pointer',
    fontFamily: "Open Sans, sans-serif",
    fontSize: '16px'
  },
  activeDate:{
    color: semanticColors.info
  }
}

Trashcan.propTypes = {
    onChange: PropTypes.func.isRequired,
    defaultValue: PropTypes.instanceOf(Date)
  };
export default Radium(Trashcan)



// WEBPACK FOOTER //
// ./src/App/Common/datepickerOnWeeks.jsx